export async function sendAccessToken(accessToken: string) {
  const worker = await navigator.serviceWorker.ready
  accessToken = accessToken[0] ?? null
  worker.active?.postMessage({ type: 'access-token', accessToken })
}
